<template>
  <div class="text-search">
    <input class="multiselect__tags" v-debounce="500" id="search" v-model.lazy="keywords" type="text"
             placeholder="Chat suchen"/>
      <i class="fa fa-search"></i>
  </div>
</template>
<script>
export default {
  name: 'FullTextSearch',
  props: ['results', 'allClientMessages'],
  data() {
    return {
      keywords: null,
    }
  },
  methods: {
    fetch() {
      this.$parent.$emit('filter', {data: {keywords: this.keywords}, filter: 'search'});
    },
  },
  watch: {
    keywords(after, before) {
      this.fetch();
    }
  },
}
</script>
<style lang="scss" scoped>
.text-search {
  position: relative;
  width: 100%;
  input {
    width: 100%;
    padding: 4px 8px;
  }
  i {
    position: absolute;
    top: 20px;
    right: 1em;
    transform: translateY(-50%);
  }
}
</style>
